var w = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
var i = (e, t, C) => t in e ? w(e, t, { enumerable: !0, configurable: !0, writable: !0, value: C }) : e[t] = C, m = (e, t) => {
  for (var C in t || (t = {}))
    n.call(t, C) && i(e, C, t[C]);
  if (a)
    for (var C of a(t))
      o.call(t, C) && i(e, C, t[C]);
  return e;
};
var s = (e, t) => {
  var C = {};
  for (var l in e)
    n.call(e, l) && t.indexOf(l) < 0 && (C[l] = e[l]);
  if (e != null && a)
    for (var l of a(e))
      t.indexOf(l) < 0 && o.call(e, l) && (C[l] = e[l]);
  return C;
};
import * as r from "react";
const h = (l) => {
  var c = l, {
    title: e,
    titleId: t
  } = c, C = s(c, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", m({ width: 32, height: 32, viewBox: "0 0 14 14", fill: "current", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t }, C), e ? /* @__PURE__ */ r.createElement("title", { id: t }, e) : null, /* @__PURE__ */ r.createElement("path", { d: "M7 0C3.14167 0 0 3.14159 0 7C0 10.8583 3.14159 14 7 14C10.8584 14 14 10.8584 14 7C14 3.14167 10.8584 0 7 0ZM7 1.2728C10.1706 1.2728 12.7273 3.82947 12.7273 7.00008C12.7273 10.1707 10.1706 12.7273 7 12.7273C3.82939 12.7273 1.27273 10.1707 1.27273 7.00008C1.27273 3.82947 3.82939 1.2728 7 1.2728ZM7 2.33341C6.64859 2.33341 6.3636 2.61839 6.3636 2.96981V7.00011C6.3636 7.17589 6.43403 7.3357 6.54914 7.4508L9.10123 10.0029C9.34981 10.2515 9.75418 10.2515 10.0028 10.0029C10.2514 9.75445 10.2514 9.34992 10.0028 9.10133L7.63638 6.73477V2.9697C7.63638 2.61828 7.35155 2.3333 6.99998 2.3333L7 2.33341Z" }));
};
export {
  h as default
};
